import { Link } from "react-router-dom";
import { ArrowLeft, Download, FileText } from "lucide-react";

export function MOG() {
    const pdfUrl = "/documenti/Puglia-Life_MOG-231_.pdf";

    return (
        <div className="container py-12 md:py-16">
            <Link to="/" className="inline-flex items-center text-text-body hover:text-brand-primary mb-8 transition-colors">
                <ArrowLeft className="h-4 w-4 mr-2" /> Torna alla Home
            </Link>
            
            <div className="max-w-4xl mx-auto">
                <div className="flex items-center gap-3 mb-6">
                    <FileText className="h-8 w-8 text-brand-primary" />
                    <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-title">Modello Organizzativo Gestionale (MOG) 231</h1>
                </div>
                
                <div className="prose prose-lg text-text-body max-w-none mb-10">
                    <p className="mb-6">
                        In questa pagina è possibile consultare e scaricare il Modello di Organizzazione, Gestione e Controllo (MOG) ai sensi del D.Lgs. 231/2001 di Puglia Life S.r.l.
                    </p>
                    <p className="mb-6">
                        Il documento definisce le regole e le procedure organizzative adottate dall'azienda per prevenire la commissione di reati e garantire una gestione etica e trasparente.
                    </p>

                    <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 mb-8">
                        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-6">
                            <h2 className="text-xl font-bold text-text-title m-0">Visualizza o Scarica il Documento</h2>
                            <a 
                                href={pdfUrl} 
                                download
                                className="inline-flex items-center px-6 py-3 bg-brand-primary text-white font-medium rounded-lg hover:bg-brand-secondary transition-colors shadow-sm whitespace-nowrap"
                            >
                                <Download className="h-5 w-5 mr-2" />
                                Scarica PDF
                            </a>
                        </div>
                        
                        <div className="w-full h-[800px] border border-gray-300 rounded-lg overflow-hidden bg-white">
                            <iframe 
                                src={pdfUrl} 
                                className="w-full h-full" 
                                title="MOG 231 Preview"
                            >
                                <p className="p-4 text-center">
                                    Il tuo browser non supporta la visualizzazione dei PDF. 
                                    <a href={pdfUrl} download className="text-brand-primary underline ml-1">Scarica il file</a> per visualizzarlo.
                                </p>
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
